<template>
  <div class="payfly-navs-tab-item">
    <a
      :class="[
        { 'dc-btn_disabled': !disabledNext },
        isBackButton ? 'dc-btn_secondary' : 'dc-btn_primary'
        ]"
      class="dc-btn dc-btn_size-md"
      href="#"
      @click.prevent="$emit('navigate')"
    >
      {{ buttonText }}
    </a>
  </div>
</template>

<script>
export default {
  name: 'NavButton',
  props: {
    disabledNext: {
      type: Boolean,
      required: true,
    },
    buttonText: {
      type: String,
      required: true,
    },
    isBackButton: {
      type: Boolean,
      default: false,
    }
  },
}
</script>

<style lang="scss">
@import "../../../sass/components/content.scss";

.dc-btn_primary {
  background-color: #0163ff !important;
  border-color: #0163ff !important;
}

</style>
